import dayjs from 'dayjs';

import { callApi } from './callApi';

const avg = (list) => list.reduce((acc, v) => acc + v, 0) / list.length;

export function parseWaves(waves) {
  const segs = waves.split(',');
  const pos = segs.shift();
  //const steps = segs.filter((_, i) => i%2 === 0).map(p => Number(p));
  const prices = segs.filter((_, i) => i%2).map(p => Number(p));
  const p1 = avg(prices.filter((_, i) => i%2 === 0));
  const p2 = avg(prices.filter((_, i) => i%2 === 1));
  return {
    avgtop: (pos === '1' ? p1 : p2).toFixed(2),
    avgbot: (pos === '2' ? p1 : p2).toFixed(2),
  };
}

export function evalExpr(code, expr) {
  if (!code)
    Promise.reject('no code to evaluate expr');

  return isNaN(Number(expr)) ?
    callApi(`/stocks/eval?code=${code}&expr=${encodeURIComponent(expr)}`) :
    Promise.resolve({val: Number(expr)});
}

export function formatCompactDateRange(startDate, endDate) {
  const compactStart = String(startDate || '').slice(5);
  const compactEnd = String(endDate || '').slice(5);
  return compactStart && compactEnd ? `${compactStart} ~ ${compactEnd}` : '';
}

export function getJobJump2InputValue(value) {
  if (value === undefined || value === null) {
    return '';
  }
  const normalized = String(value).trim();
  return normalized === '-1' ? '' : normalized;
}

export function toJobJump2StorageValue(value) {
  const normalized = String(value ?? '').trim();
  if (normalized === '') {
    return -1;
  }
  const target = Number.parseInt(normalized.replace('%', ''), 10);
  return target === 0 ? -1 : target;
}

export function formatJobJump2Target(value) {
  const normalized = getJobJump2InputValue(value);
  if (normalized === '') {
    return '-';
  }
  return normalized.endsWith('%') ? normalized : `${normalized}%`;
}

export function getCrossDayDefaultOverflowPercent(value) {
  const raw = value && typeof value === 'object' && !Array.isArray(value)
    ? value.default
    : value;
  const percent = Number(raw);
  return Number.isFinite(percent) && percent >= 0 ? percent : 0;
}

export function getCrossDayBusinessDateKey(displayDayparts, now=dayjs()) {
  const match = /^(\d{2}):(\d{2})-/.exec(String(displayDayparts || ''));
  if (!match) return now.format('YYYYMMDD');
  const boundary = now.startOf('day').hour(Number(match[1])).minute(Number(match[2]));
  return (now.isBefore(boundary) ? now.subtract(1, 'day') : now).format('YYYYMMDD');
}

export function getCrossDayOverflowPercentForDay(value, day) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return getCrossDayDefaultOverflowPercent(value);
  }
  const percent = Number(value[day]);
  return Number.isFinite(percent) && percent >= 0
    ? percent
    : getCrossDayDefaultOverflowPercent(value);
}
